import { useEffect, useState } from "react";
import { useData } from "@/lib/data";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SoleCardSelect, saveVariant } from "@/components/ColorVariantParts";
import { toast } from "sonner";
import PhotoPicker from "@/components/PhotoPicker";

// Adds/edits one color variant (= one stock card) of a model code
export default function ColorVariantDialog({ open, onOpenChange, model, editing, onSaved }) {
  const { soleCards } = useData();
  const [form, setForm] = useState({ model_color: "", sole_code: "", sole_color: "", note: "" });
  const [saving, setSaving] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [photoRemoved, setPhotoRemoved] = useState(false);

  useEffect(() => {
    if (open) { setPhoto(null); setPhotoRemoved(false); }
  }, [open]);

  useEffect(() => {
    if (open) setForm(editing
      ? { model_color: editing.model_color, sole_code: editing.sole_code, sole_color: editing.sole_color, note: editing.note }
      : { model_color: "", sole_code: "", sole_color: "", note: "" });
  }, [open, editing]);

  const submit = async () => {
    if (!form.model_color.trim()) { toast.error("Renk zorunlu"); return; }
    const body = { ...form, model_code: model.model_code, season: model.season || "" };
    setSaving(true);
    try {
      await saveVariant(editing, body, photo, photoRemoved);
      toast.success(editing ? "Renk güncellendi" : `${model.model_code} · ${form.model_color} eklendi`);
      onOpenChange(false);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118] max-w-lg" data-testid="color-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase tracking-tight">
            {model?.model_code} · {editing ? "Rengi Düzenle" : "Renk Ekle"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs text-[#6B5B4A] mb-1 block">Fotoğraf</Label>
            <PhotoPicker currentPath={editing?.photo_path} file={photo} onFile={setPhoto}
              removed={photoRemoved} onRemove={() => setPhotoRemoved(true)} />
          </div>
          <div>
            <Label className="text-xs text-[#6B5B4A]">Renk *</Label>
            <Input data-testid="color-name-input" value={form.model_color} placeholder="Örn: Siyah Rugan"
              onChange={(e) => setForm({ ...form, model_color: e.target.value })} className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          <SoleCardSelect soleCards={soleCards} form={form} setForm={setForm} />
          <div>
            <Label className="text-xs text-[#6B5B4A]">Not</Label>
            <Input data-testid="color-note-input" value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })} className="mt-1 h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={saving} data-testid="color-submit-btn"
            className="bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide h-11 px-6">
            {saving ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
